<nav class="navbar navbar-expand-xl box-shadow">
  <a class="navbar-brand">SMART E-TAX</a>
  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto"></ul>
    <ul class="navbar-nav align-middle">
      <div ngbDropdown placement="bottom-right" id="userArea" class="d-inline-block align-middle text-white">
        <select class="form-control form-control-sm language-switcher" style="vertical-align: middle;
        width: auto; height: auto ;display: inline"
                (change)="changeLanguage(language)"
                [(ngModel)]="language">
          <option value="en">&nbsp;EN</option>
          <option value="th">&nbsp;TH</option>
        </select>
      </div>
    </ul>
  </div>
</nav>

<div class="container">
  <div class="header text-center pt-3">
    <h3>{{ 'DOCUMENT-APPROVAL.DOCUMENT-PREVIEW' | translate}}</h3>
  </div>

  <div *ngIf="showSubmissionComplete" class="text-center text-success pb-4">
    {{ 'DOCUMENT-APPROVAL.SUBMIT-COMPLETE' | translate}}
  </div>

  <div class="position-relative z-2" *ngIf="!errorMsg">
    <div class="text-center">
      <ng-container *ngIf="!isLoading">
        <div [hidden]="pdfError && !pdfLoaded">
          <pdf-viewer [src]="pdf" [render-text]="true" [show-all]="false" [(page)]="pdfPage"
            (after-load-complete)="setPDF($event)">
          </pdf-viewer>

          <div class="mb-2">
            <a href="javascript:void(0)" class="text-secondary" (click)="prevPage()"
              [ngStyle]="{'visibility': (pdfPage === 1) ? 'hidden' : 'visible'}">
              <em class="fas fa-chevron-left m-r-5"></em>
            </a>
            <span class="text-bold" style="color: #02008a;">
              {{ ('Page') + ' ' + pdfPage + ' ' + ('of') + ' ' + pdfPageLength }}
            </span>
            <a href="javascript:void(0)" class="text-secondary" (click)="nextPage()"
              [ngStyle]="{'visibility': (pdfPage === pdfPageLength) ? 'hidden' : 'visible'}">
              <em class="fas fa-chevron-right m-l-5"></em>
            </a>
          </div>
        </div>
        <span class="text-center text-danger text-bold" *ngIf="pdfError">{{ pdfError }}</span>
      </ng-container>
      <app-loading-spinner [isLoading]="isLoading"></app-loading-spinner>
    </div>
    <div class="my-4 text-center" *ngIf="!isLoading && !showSubmissionComlete">
      <button class="btn btn-dv btn-clean btn-wide m-r-5" (click)="rejectTaxData()">
        {{ 'NORMAL.REJECT' | translate}}
      </button>
      <button class="btn btn-dv btn-wide m-r-5" (click)="approveTaxData()" *ngIf="!pdfError">
        {{ 'NORMAL.APPROVE' | translate}}
      </button>
    </div>
  </div>

  <div *ngIf="errorMsg">
    <div class="text-center text-red">
      {{ errorMsg }}
    </div>
    <div class="my-4 text-center">
      <button class="btn btn-dv btn-wide m-r-5" (click)="back()" *ngIf="haveTaxData">
        {{ 'TEXT.BACK' | translate}}
      </button>
    </div>
  </div>
</div>

<ng-template #approveModal let-modal>
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12 text-center">
        <h5>{{ 'DOCUMENT-APPROVAL.CONFIRM-APPROVE' | translate}}</h5>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="col-6 text-left">
      <button type="button" class="btn btn-dv btn-clean btn-wide"
              (click)="closeModal()">{{ 'TEXT.CANCEL' | translate}}
      </button>
    </div>
    <div class="col-6 text-right p-0">
      <button type="button" class="btn btn-dv btn-wide" [disabled]="confirmLoading" (click)="confirm()">
        <i *ngIf="confirmLoading" class="fa fa-spinner fa-spin m-r-5"></i>
        {{ 'TEXT.CONFIRM' | translate}}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #rejectModal let-modal>
  <div class="modal-header">
    <h5>{{ 'TEXT.CUSTOMER-INFORMATION' | translate}}</h5>&nbsp;&nbsp;&nbsp;
    <div ngbDropdown placement="bottom-right" id="userArea" class="d-inline-block align-middle text-white">
      <select class="form-control form-control-sm language-switcher" style="vertical-align: middle;
      width: auto; height: auto ;display: inline"
              (change)="changeLanguage(language)"
              [(ngModel)]="language">
        <option value="en">&nbsp;EN</option>
        <option value="th">&nbsp;TH</option>
      </select>
    </div>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div [formGroup]="customerForm">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group row">
            <div class="col-md-4">
              <label for="name">{{ 'NORMAL.NAME' | translate}}</label>
            </div>
            <div class="col-md-8">
              <input class="form-control" type="text" id="name" formControlName="name">
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group row">
            <div class="col-md-4">
              <label for="tax-id">{{ 'ISSUE-TEXT.TAX-ID' | translate}}</label>
            </div>

            <div class="col-md-8">
              <input class="form-control" type="text" id="tax-id" formControlName="taxID">
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group row">
            <div class="col-md-4">
              <label for="branch-code">{{ 'TABLE.BRANCH-CODE' | translate}}</label>
            </div>

            <div class="col-md-8">
              <input class="form-control" type="text" id="branch-code" formControlName="branchCode">
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group row">
            <div class="col-md-4">
              <label for="address">{{ 'FILTER.ADDRESS' | translate}}</label>
            </div>

            <div class="col-md-8">
              <textarea class="form-control" id="address" rows="3" formControlName="address"></textarea>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group row">
            <div class="col-md-4">
              <label for="postal-code">{{'DATA.DELIVERY-POSTALCODE'|translate}}</label>
            </div>

            <div class="col-md-8">
              <input class="form-control" type="text" id="postal-code" formControlName="postCode">
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-4">
              <label for="country">{{ 'DATA.COUNTRY'|translate }}</label>
            </div>

            <div class="col-md-8">
              <input class="form-control" type="text" id="country" formControlName="countryCode">
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group row">
            <div class="col-md-4">
              <label for="email">{{'EMAIL-DASHBOARD.EMAIL'|translate}}</label>
            </div>

            <div class="col-md-8">
              <input class="form-control" type="text" id="email" formControlName="email">
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group row">
            <div class="col-md-4">
              <label for="cc-email">{{'EMAIL-DASHBOARD.CC-EMAIL'|translate}}</label>
            </div>

            <div class="col-md-8">
              <input class="form-control" type="text" id="cc-email" formControlName="ccEmail">
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group row">
            <div class="col-md-2">
              <label for="remark">{{'ISSUE-TEXT.REMARK'|translate}}</label>
            </div>

            <div class="col-md-10">
              <textarea class="form-control" id="remark" rows="3" formControlName="remark"></textarea>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group row">
            <div class="col-md-2">
              <label for="contact">{{'DOCUMENT-APPROVAL.CONTACT'|translate}}<span class="text-danger text-left">*</span></label>
            </div>

            <div class="col-md-10">
              <textarea class="form-control" id="contact" rows="3" formControlName="contact"></textarea>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="col-6 text-left">
      <button type="button" class="btn btn-dv btn-clean btn-wide"
              (click)="closeModal()">{{'TEXT.CANCEL'|translate}}
      </button>
    </div>
    <div class="col-6 text-right p-0">
      <button type="button" class="btn btn-dv btn-wide" [disabled]="confirmLoading" (click)="confirm()">
        <i *ngIf="confirmLoading" class="fa fa-spinner fa-spin m-r-5"></i>
        {{'TEXT.SUBMIT'|translate}}
      </button>
    </div>
  </div>
</ng-template>



// WEBPACK FOOTER //
// /opt/app/src/app/features/document-approval/document-approval-preview/document-approval-preview.component.html